module.exports = __webpack_public_path__ + "static/1-4dddc14a8679964219a5967e17cf1df1.jpg";